module.exports = __webpack_public_path__ + "static/img/zlpy.ba94026f.png";